// app/javascript/functions/dandelion_background.js
// adds pixels to whole page
// JS-generated pixels for the dandelion effect
export function createDandelion(count, colors, size = 10) {
    const pageHeight = document.documentElement.scrollHeight;
    for (let i = 0; i < count; i++) {
        const pixel = document.createElement('div');
        pixel.classList.add('pixel');
        pixel.style.backgroundColor = colors[Math.floor(Math.random() * colors.length)];
        const size = Math.ceil(Math.random() * 15);
        pixel.style.width = `${size}px`;
        pixel.style.height = `${size}px`;
        const opacity = Math.random();
        pixel.style.opacity = opacity < 0.3 ? 0.3 : opacity;
        document.body.appendChild(pixel);
        placePixel(pixel, i, count, pageHeight);
        // placePixel(pixel, i, count);
    }
    // Simulate dandelion animation completion after a delay
    setTimeout(() => {
        const event = new CustomEvent('dandelion:finished');
        document.dispatchEvent(event);
    }, 500); // Adjust the delay as needed based on your animation duration
}

function placePixel(pixel, i, total, pageHeight) {
    // Favoring right and bottom positions
    if (i < total / 2) {
        pixel.style.left = `${50 + Math.random() * 50}vw`; // Start from the middle to the right of the viewport
        pixel.style.top = `${Math.random() * pageHeight}px`;
        // pixel.style.left = `${Math.random() * 50}vw`;
        // pixel.style.top = `${Math.random() * 50}vh`;
    } else {
        pixel.style.right = `${50 + Math.random() * 50}vw`; // Start from the middle to the right of the viewport
        pixel.style.bottom = `${Math.random() * pageHeight}px`;
        // pixel.style.right = `${Math.random() * 50}vw`;
        // pixel.style.bottom = `${Math.random() * 50}vh`;
    }
}
